import React from 'react';
import { BaseScenarioLayout } from '../base/BaseScenarioLayout';
import { SessionBox } from '../../SessionBox/SessionBox';
import { ConnectedDevices, SessionCharts } from '../../index';
import type { DeviceConfigurationApi } from '@model/DeviceConfiguration';
import type { DeviceConnectionStatus, Device } from '@types';

interface PerformanceScenarioLayoutProps {
  session: DeviceConfigurationApi;
  appRequirements: { vr: boolean; sensor: boolean };
  allDevices: Device[];
  connectionStatus: Record<string, DeviceConnectionStatus>;
  onConfigureClick: () => void;
  isLoading: boolean;
}

export const PerformanceScenarioLayout =
  React.memo<PerformanceScenarioLayoutProps>(
    ({
      session,
      appRequirements,
      allDevices,
      connectionStatus,
      onConfigureClick,
      isLoading,
    }) => {
      const sessionBox = (
        <SessionBox
          session={session}
          appRequirements={appRequirements}
          allDevices={allDevices}
          connectionStatus={connectionStatus}
          isLoading={isLoading}
        />
      );

      const devicesBox = (
        <ConnectedDevices
          onConfigureClick={onConfigureClick}
          vrRequired={appRequirements.vr}
          sensorRequired={appRequirements.sensor}
          devices={allDevices}
          session={session}
        />
      );

      const chartBox = <SessionCharts session={session} />;

      return (
        <BaseScenarioLayout
          session={session}
          sessionBox={sessionBox}
          devicesBox={devicesBox}
          chartBox={chartBox}
        />
      );
    }
  );

PerformanceScenarioLayout.displayName = 'PerformanceScenarioLayout';
